<template>
  <div v-if="title">
    <b-input-group size="sm">
      <template v-slot:prepend>
        <b-input-group-text>
          <span class="d-inline d-md-none">{{ title['0'] }}</span><span class="d-none d-md-inline">{{ title[1] }}</span>
        </b-input-group-text>
      </template>
      <b-form-select v-if="register.options.length > 0" :options="register.options" v-model="register.current" @change="Select"></b-form-select>
      <b-form-input readonly v-else size="sm" value="Справочник сотрудников не заполнен"></b-form-input>
    </b-input-group>

  </div>

  <div v-else>
    <b-form-select size="sm" v-if="register.options.length > 0" :options="register.options" v-model="register.current" @change="Select"></b-form-select>
    <b-form-input readonly v-else size="sm" value="Справочник сотрудников не заполнен"></b-form-input>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'SelectWorkers',
  components: {

  },
  props: ['title'],

  methods: {
    Select: function () {

      if (this.org) {
        this.$http
            .post(this.$apiold, {
              task: 'list',
              mode: 'select',
              id: this.register.current,
              orgid: this.orgs.current.id,
              params: {name: 'workers', table: 'reg_workers', order: ' ORDER BY last_name ASC, first_name ASC, middle_name ASC'},
              changed: true
            })
            .then(response => {
              this.$store.commit('regChange', {name: 'workers', register: response.data.register});
            });
      }
      else {
        this.$http
            .post(this.$apiold, {
              task: 'list',
              mode: 'select',
              id: this.register.current,
              orgid: this.orgs.current.id,
              params: {name: 'workers', table: 'reg_workers', org: true, order: ' ORDER BY last_name ASC, first_name ASC, middle_name ASC'},
              changed: true
            })
            .then(response => {
              this.$store.commit('regChange', {name: 'workers', register: response.data.register});
            });


      }

    }
  },
  computed: {
    ...mapGetters({
      orgs: 'orgs',
      user: "user"
    }),
    register: {
      get() {
        return this.$store.getters.regSelect('workers', ['last_name', 'first_name', 'middle_name'], true);
      }
    }
  }
}
</script>
